/**
 * Single place for all env-derived config (Vue CLI injects process.env at build time).
 * Use ENV_VALUES across the app instead of process.env to keep env usage centralized.
 */
export type FormUIEnv = {
  VUE_APP_VERSION: string;
  NODE_ENV: string;
  BASE_URL: string;
  VUE_APP_ORGOLAS_BASE_URL: string;
  VUE_APP_AUTH_API_BASE_URL: string;
  VUE_APP_BUNDURIL_BASE_URL: string;
  VUE_APP_BASE_URL_S3_ASSETS: string;

  VUE_APP_SENTRY_ENABLED: boolean;
  VUE_APP_SENTRY_DSN: string | undefined;
  VUE_APP_SENTRY_LOGS_ENABLED: boolean;
};

export const ENV_VALUES: FormUIEnv = {
  VUE_APP_VERSION: process.env.VUE_APP_VERSION!,
  NODE_ENV: process.env.NODE_ENV!,
  BASE_URL: process.env.BASE_URL || '',
  VUE_APP_ORGOLAS_BASE_URL: process.env.VUE_APP_ORGOLAS_BASE_URL!,
  VUE_APP_AUTH_API_BASE_URL: process.env.VUE_APP_AUTH_API_BASE_URL!,
  VUE_APP_BUNDURIL_BASE_URL: process.env.VUE_APP_BUNDURIL_BASE_URL!,
  VUE_APP_BASE_URL_S3_ASSETS: process.env.VUE_APP_BASE_URL_S3_ASSETS!,

  VUE_APP_SENTRY_ENABLED: process.env.VUE_APP_SENTRY_ENABLED === 'true',
  VUE_APP_SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN,
  VUE_APP_SENTRY_LOGS_ENABLED: process.env.VUE_APP_SENTRY_LOGS_ENABLED === 'true',
};

export const IS_DEV = ENV_VALUES.NODE_ENV === 'development';
